






























import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ImagesType, RowType } from '~/types/solepro/PageBuilder';
import VideoBackground from '~/mixins/solepro/VideoBackground.vue';
import { GenericObjectType } from '~/utils/types';
import { trackPageBuilderButton } from '~/helpers/trackings/24orepro/components';
import { useRouter } from '@nuxtjs/composition-api';

export default defineComponent({
    name: "Row",
    mixins: [PageBuilderComponent, VideoBackground],
    props: {
        node: {
            type: Object as PropType<RowType>,
            required: true
        },
        customProps:{
            type: Object as PropType<GenericObjectType>,
                default: ()=>{ return {}}
        }
    },
    components: {
        PageBuilderComponent
    },
    setup(props) {
        const content = props.node;
        const hasParallax = content.enableParallax == '1' && content.backgroundImages != "" && content.backgroundImages != "{}";
        const isLink = !!content.soleProfessionistiUrl;
        const WrapperComponent = hasParallax ? () => import('~/components/Parallax.vue') : (isLink ? () => import('~/components/solepro/Link.vue') : 'div')
        const isTrack = !!content.soleProfessionistiTrack;
        const hasIframe = content.videoSrc && !content.videoSrc.endsWith('.mp4');
        const parseBackgroundImages = (raw: string): ImagesType | null => {
            try {
                return JSON.parse(raw.replace(/\\/g, '')) as ImagesType;
            } catch {
                return null;
            }
        };
        const backgroundImage = content.backgroundImages ? parseBackgroundImages(content.backgroundImages) : null;
        const hasBackgroundImage = !!backgroundImage?.desktop_image;
        const bgPositionMatch = (content.cssClasses || []).map((c: string) => c.match(/^(!?)bg-(\[.+\])$/)).find(Boolean);
        const backgroundImagePositionClass = bgPositionMatch ? `${bgPositionMatch[1]}object-${bgPositionMatch[2]}` : null;
        const router = useRouter();
        const callbackFn = ()=>{
            if (content.target == '_blank') {
                window.open(content.soleProfessionistiUrl, content.target).focus();
            } else {
                location.href = `${content.soleProfessionistiUrl}`;
            }  
    };
        const trackFunction = (e,callbackFn?:Function) => {
            e.preventDefault();
            trackPageBuilderButton(content.soleProfessionistiTrack, content.soleProfessionistiUrl, content.target ?? null, callbackFn);
        }
        const trackRow = (e) => isTrack && isLink ? trackFunction(e,callbackFn) : callbackFn()

        return {
            trackRow,
            WrapperComponent,
            content,
            hasIframe,
            hasParallax,
            backgroundImage,
            hasBackgroundImage,
            backgroundImagePositionClass,
            isContained: content.appearance == 'contained',
            isFullWidth: content.appearance == 'full-width',
        }
    }
})
